
import CbFormTextWithTitle from "@/components/layouts/content-blocks/forms/CbFormTextWithTitle.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default {
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormTextWithTitle}
}
